/*
 * Shopify's legal policies are stored as flat text. Every section label
 * ("Eligibility", "How to start a return") comes through as an ordinary
 * paragraph, and the gaps between sections are whitespace-only paragraphs.
 * The result has no hierarchy for a reader and none for a screen reader
 * either: one <h1> and then forty identical paragraphs.
 *
 * Editing the policy source needs the write_legal_policies scope, which this
 * app does not hold, so the structure is restored here instead. Nothing is
 * reworded. A paragraph is promoted to a heading only when it looks like a
 * label: short, no sentence-ending punctuation, and sitting directly after a
 * blank spacer paragraph.
 */
(function () {
  var body = document.querySelector('.shopify-policy__body .rte');
  if (!body) return;

  var isBlank = function (el) {
    return el.tagName === 'P' && !el.textContent.replace(/[\s ]/g, '').length;
  };

  var looksLikeLabel = function (el) {
    if (el.tagName !== 'P') return false;
    var text = el.textContent.trim();
    if (!text || text.length > 60) return false;
    if (/[.!?:,;]$/.test(text)) return false;
    if (el.querySelector('a, ul, ol, img')) return false;
    // A label introduces something, so there has to be something after it.
    return !!el.nextElementSibling;
  };

  var kids = Array.prototype.slice.call(body.children);

  kids.forEach(function (el, i) {
    var prev = kids[i - 1];
    if (!prev || !isBlank(prev)) return;
    if (!looksLikeLabel(el)) return;

    // Move the existing nodes rather than re-parsing markup: same content,
    // no HTML string round-trip.
    var h = document.createElement('h2');
    while (el.firstChild) h.appendChild(el.firstChild);
    el.parentNode.replaceChild(h, el);
  });

  // The spacer paragraphs did the job of margins. Real margins do it better.
  kids.forEach(function (el) {
    if (isBlank(el) && el.parentNode) el.parentNode.removeChild(el);
  });

  body.setAttribute('data-kl-structured', 'true');
})();
